export default __webpack_public_path__ + "static/media/Ventilatie.bb8f0f55.svg";